import { render, staticRenderFns } from "./UserInviteModal.vue?vue&type=template&id=53158047&"
import script from "./UserInviteModal.vue?vue&type=script&lang=js&"
export * from "./UserInviteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports